<div class="p-2" lohiPageTitle="Drivers">
  <div class="flex justify-end items-center">
    <div class="mr-2" *lohiFeatureFlag="'driverScheduling'">
      <a routerLink="/scheduling" mat-stroked-button color="primary" *lohiIsNotOnlyFiveFTourOwner>Schedule Groups</a>
    </div>
    <div class="mr-2" *lohiFeatureFlag="'eldManagement'">
      <a routerLink="/eld_management/driver_groups" mat-stroked-button color="primary">ELD Management</a>
    </div>
    <div class="mr-2" *lohiFeatureFlag="'driverCutGroups'">
      <a routerLink="/driver-cuts/management" mat-stroked-button color="primary">Driver Cut Groups</a>
    </div>
    <a *lohiRelationship="'saas'" routerLink="../invite_driver" type="button" mat-stroked-button color="primary"
      >Invite User</a
    >
    <ng-container *lohiRelationship="['broker', 'carrier']">
      <ng-container *ngIf="(userInfo$ | async)?.isCompanyFiveFTourOnly === true; else nonTourInvite">
        <a
          *lohiRelationship="['broker']"
          routerLink="../invite_tour_driver"
          type="button"
          mat-stroked-button
          color="primary"
          >Invite 5F Tours User</a
        >
      </ng-container>
      <ng-template #nonTourInvite>
        <button mat-stroked-button color="primary" [matMenuTriggerFor]="oaMenu">Invite User</button>
        <mat-menu #oaMenu="matMenu">
          <a class="flex items-center" target="_blank" href="{{ inviteDriverUrl }}" mat-menu-item
            ><span>Invite Driver</span><mat-icon>launch</mat-icon></a
          >
          <a routerLink="../invite_admin" mat-menu-item>Invite Admin (Non Driver)</a>
        </mat-menu>
      </ng-template>
    </ng-container>
  </div>
  <div class="text-lg font-bold p-1" *ngIf="activeDrivers$ | async as activeDrivers">
    Active Drivers ({{ activeDrivers.length }})
  </div>
  <div class="grid grid-cols-2">
    <div
      class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-start items-center"
      (click)="setSortHeader('driverName')"
    >
      Name
      <lohi-sort-indicator [activeColumn]="sortBy === 'driverName'" [reversed]="sortReverse"></lohi-sort-indicator>
    </div>
    <div class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-end items-center">Status</div>
  </div>

  <div *ngIf="activeDrivers$ | async as activeDrivers">
    <ng-container *ngIf="activeDrivers.length; else noActiveDrivers">
      <a
        *ngFor="let driver of activeDrivers; trackBy: activeDrivers | trackByKey2: 'id'"
        class="grid grid-cols-2 even:bg-gray-300 py-2"
        routerLink="../{{ driver.id }}"
      >
        <div class="flex flex-col pl-2">
          <div>
            <div class="flex">
              <span class="font-bold">{{ driver.driverName }}</span>
              <ng-container *lohiIsNotOnlyFiveFTourOwner>
                <ng-container *lohiRelationship="['broker', 'carrier']">
                  <div
                    *ngIf="driver.userTakeRateName"
                    class="ml-1 rounded-full px-1"
                    [ngClass]="{
                      'text-white':
                        driver.userTakeRateName === 'Black' ||
                        driver.userTakeRateName === 'Silver' ||
                        driver.userTakeRateName === 'Blue',
                      'bg-black': driver.userTakeRateName === 'Black',
                      'bg-yellow-500': driver.userTakeRateName === 'Gold',
                      'bg-gray-600': driver.userTakeRateName === 'Silver',
                      'bg-blue-500': driver.userTakeRateName === 'Blue'
                    }"
                  >
                    {{ driver.userTakeRateName }} - {{ 1 - driver.userTakeRate | percent: '0.0-2' }}
                  </div>
                  <span class="ml-1 px-2 rounded-md border-2 text-right whitespace-nowrap" *ngIf="driver.currentPoints !== null">{{ driver.currentPoints | number }} pts</span>
                </ng-container>
              </ng-container>
            </div>
            <ng-container *lohiIsNotOnlyFiveFTourOwner>
              <mat-icon *ngIf="!driver.allowShiftBooking" class="text-red-500" matTooltip="Blocked from Booking Shifts">
                event_busy
              </mat-icon>
            </ng-container>
          </div>
          <ng-container *lohiIsNotOnlyFiveFTourOwner>
            <div class="text-red-500" *ngIf="driver.driverCut == null" (click)="navigateToProfile($event, driver.id)">
              <span
                tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
                >Set this driver's Earnings Percentage</span
              >
            </div>
          </ng-container>
          <div>
            <a class="text-blue-500" href="tel: {{ driver.phoneNumber }}" (click)="$event.stopPropagation()">{{
              driver.phoneNumber | phone
            }}</a>
          </div>
          <div *ngIf="driver.employeeId">
            <div class="text-gray-700">{{ driver.employeeId }}</div>
          </div>
        </div>
        <div class="flex justify-end items-center" *lohiIsNotOnlyFiveFTourOwner>
          <ng-container *ngIf="driver.inProgressShift">
            <div class="text-gray-700 text-right">
              On Shift Until {{ driver.inProgressShift?.endTimestamp | standardDate }}
            </div>
          </ng-container>
          <ng-container *ngIf="driver.upcomingShift">
            <div class="text-gray-700 text-right">
              Upcoming Shift at {{ driver.upcomingShift.startTimestamp | standardDate }}
            </div>
          </ng-container>
        </div>
      </a>
    </ng-container>
    <ng-template #noActiveDrivers>
      <div class="border-b border-gray-500 pl-2 pr-2 pb-1 text-gray-600">No Active Drivers</div>
    </ng-template>
  </div>
  <div *ngIf="pendingDrivers$ | async as pendingDrivers">
    <div class="text-lg font-bold pb-2 p-1 pt-3">Pending Drivers ({{ pendingDrivers.length }})</div>
    <ng-container *ngIf="pendingDrivers.length; else noPendingDrivers">
      <div
        *ngFor="let driver of pendingDrivers; trackBy: 'id' | trackByKey"
        class="border-b border-gray-500 last:border-0 pl-2 pr-2 pb-1"
      >
        <div class="font-bold">
          {{ driver.driverName }}
          <a class="underline text-blue-500" href="tel: {{ driver.phoneNumber }}" (click)="$event.stopPropagation()">{{
            driver.phoneNumber | phone
          }}</a>
        </div>
      </div>
    </ng-container>
    <ng-template #noPendingDrivers>
      <div class="border-b border-gray-500 pl-2 pr-2 pb-1 text-gray-600">No Pending Drivers</div>
    </ng-template>
  </div>
</div>
